import { render, staticRenderFns } from "./MailComponent.vue?vue&type=template&id=bb348b06&scoped=true&"
import script from "./MailComponent.vue?vue&type=script&lang=js&"
export * from "./MailComponent.vue?vue&type=script&lang=js&"
import style0 from "./MailComponent.vue?vue&type=style&index=0&id=bb348b06&scoped=true&lang=scss&"
import style1 from "./MailComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb348b06",
  null
  
)

export default component.exports